import React, { useRef, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material/";
import {
    containerBox,
    canvasBox,
    canvasStyle,
    legendBoxContainer,
    getLegendItemStyles,
    legendColorBox
} from "./styles";

const DonutChart = ({ data, onToggleView }) => {
    const canvasRef = useRef(null);
    const [hoveredLegend, setHoveredLegend] = useState(null);
    const [animationProgress, setAnimationProgress] = useState(1);

    /** On hover over legend  */
    useEffect(() => {
        let progress = 0;
        const step = 0.05;
        let animationFrameId = null;

        const animate = () => {
            progress += step;
            setAnimationProgress(Math.min(progress, 1));
            /** Use rquest animate frame for violation warning  */
            if (progress < 1) {
                animationFrameId = requestAnimationFrame(animate);
            }
        };

        if (hoveredLegend) {
            animationFrameId = requestAnimationFrame(animate);
        } else {
            setAnimationProgress(1);
        }

        return () => {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
            }
        };
    }, [hoveredLegend]);

    /** Constructing donut chart  */
    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        const width = (canvas.width = 250);
        const height = (canvas.height = 250);
        const centerX = width / 2;
        const centerY = height / 2;
        const baseRadius = Math.min(width, height) / 2.5;
        const holeRadius = baseRadius * 0.5;
        const zoomFactor = 1.1;

        const total = data.reduce((sum, item) => sum + item.value, 0);
        let startAngle = -Math.PI / 2;

        ctx.clearRect(0, 0, width, height);
        ctx.save();

        data.forEach((item) => {
            const sliceAngle = (item.value / total) * (2 * Math.PI);
            const endAngle = startAngle + sliceAngle;
            const isHovered = hoveredLegend === item.label;
            const targetRadius = isHovered
                ? baseRadius * zoomFactor
                : baseRadius;
            const radius =
                baseRadius + (targetRadius - baseRadius) * animationProgress;

            ctx.beginPath();
            ctx.moveTo(centerX, centerY);
            ctx.arc(centerX, centerY, radius, startAngle, endAngle);
            ctx.closePath();
            ctx.fillStyle = item.color;
            ctx.fill();

            startAngle = endAngle;
        });

        ctx.beginPath();
        ctx.arc(centerX, centerY, holeRadius, 0, 2 * Math.PI);
        ctx.fillStyle = "#ffffff";
        ctx.fill();

        ctx.restore();
    }, [data, hoveredLegend, animationProgress]);

    return (
        <Box sx={containerBox}>
            <Box sx={canvasBox}>
                <canvas ref={canvasRef} style={canvasStyle}></canvas>
            </Box>
            <Box sx={legendBoxContainer}>
                {data.map((item) =>
                    item.value > 0 ? (
                        <Box
                            key={item.label}
                            sx={getLegendItemStyles(
                                hoveredLegend === item.label,
                                item.color
                            )}
                            onClick={() => {
                                if (onToggleView) {
                                    item.onClick && item.onClick();
                                    onToggleView("table");
                                }
                            }}
                            onMouseEnter={() => setHoveredLegend(item.label)}
                            onMouseLeave={() => setHoveredLegend(null)}
                        >
                            <Box
                                sx={{
                                    ...legendColorBox,
                                    backgroundColor: item.color
                                }}
                            />
                            <Typography variant="body2">
                                {item.label}
                            </Typography>
                        </Box>
                    ) : null
                )}
            </Box>
        </Box>
    );
};

export default DonutChart;
